import React from 'react';
import { FormattedMessage } from 'react-intl';

import MuiChip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import MuiButton, { ButtonProps } from '@mui/material/Button';
import MuiLoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

import { PaymentProviderStatuses } from '@/domain/paySettings/helpers';

import { styled } from '@mui/material/styles';

export const Chip = styled(MuiChip)(() => ({
  borderRadius: 4,
}));

export const createStatuses = {
  [PaymentProviderStatuses.connected]: (
    <Chip
      color="success"
      label={<FormattedMessage id="settings.connections.connected" defaultMessage="Connected" />}
      size="small"
    />
  ),
};

export const Container = styled(Box)(({ theme }) => ({
  marginBottom: 1.5,
  marginTop: '12px !important',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: (theme.shape.borderRadius as number) * 2,
  boxShadow: 'none',
  backgroundColor: theme.palette.grey[50],
  height: 66,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 2),
}));

export const Button: React.FC<ButtonProps> = ({ onClick, ...rest }) => (
  <MuiButton
    {...rest}
    onClick={(...args: Parameters<NonNullable<ButtonProps['onClick']>>) => {
      args[0].stopPropagation();
      if (typeof onClick === 'function') onClick(...args);
    }}
  />
);

export const LoadingButton: React.FC<LoadingButtonProps> = ({ onClick, ...rest }) => (
  <MuiLoadingButton
    {...rest}
    onClick={(...args: Parameters<NonNullable<LoadingButtonProps['onClick']>>) => {
      args[0].stopPropagation();
      if (typeof onClick === 'function') onClick(...args);
    }}
  />
);
